import React from 'react';
import PropTypes from 'prop-types';
import { Form, Field } from 'formik';

import ProfileInput from '../../form/ProfileInput';
import AuthSubmitButton from '../common/AuthSubmitButton';

const RegisterForm = props => {
  return (
    <Form noValidate>
      {props.errors.summary && <div className="notification is-danger">{props.errors.summary}</div>}
      <Field name="name" component={ProfileInput} placeholder="Name" disabled={props.isSubmitting} />
      <Field name="email" type="email" component={ProfileInput} placeholder="Email" disabled={props.isSubmitting} />
      <Field
        name="password"
        type="password"
        component={ProfileInput}
        placeholder="Password"
        disabled={props.isSubmitting}
      />
      <Field
        name="confirmPassword"
        type="password"
        component={ProfileInput}
        placeholder="Confirm password"
        disabled={props.isSubmitting}
      />
      <AuthSubmitButton title="Register" isSubmitting={props.isSubmitting} />
    </Form>
  );
};

RegisterForm.propTypes = {
  errors: PropTypes.object.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
};

export default RegisterForm;
